<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre3" id="pgepubid00000">The Hollow Lens</h1>
<div class="calibre4">Another adventure of Chester Fay</div>
<div class="figcenter">
<img alt="" class="calibre5" id="id-5929170666949775180" src="Images/img0002.jpg"/>
</div>
<blockquote class="calibre6"><div class="pg-boilerplate">
<p class="calibre7">The author of “Beyond the Wall,” “Whispering Wires,”
and “Peterman’s Luck” is at his best in this fascinating
story of underworld life.</p>
</div>
</blockquote>
<p class="calibre8">In the _argot_ of the underworld, Chester Fay, alias Edward Letchmere,
an expert on other people’s strong-boxes, had lammistered to Short
Hills, California, where an excellent golf-links surrounds a
half-hotel, half-clubhouse of the superior order.</p>
<p class="calibre8">After finishing a game, upon the twelfth day of his stay at Short
Hills, Fay tossed his golf-bag to the turf, dismissed his caddy and sat
down at the Nineteenth Hole, where refreshments were at that time
available.</p>
<p class="calibre8">The girl who entered his life, a few minutes after he was seated, came
diagonally from the clubhouse. He mentally concluded that she had been
waiting on the porch for the game to finish.</p>
<p class="calibre8">She wore a picture-hat, carried a parasol and was extremely cool, as
was attested by her manner as she drew a chair up to his table and
said:</p>
<p class="calibre8">“I’m Charlie Laurie’s only daughter.”</p>
<p class="calibre8">Had the California sky fallen upon the links, Fay would not have been
more surprised. Charlie Laurie was serving fifty years in the Isolation
Section of Dannemora for the crime, committed against the dignity of
New York State, of forcing open a national bank, seizing the contents
of the vault and escaping to Argentina, where he was later turned up by
a former pal.</p>
<p class="calibre8">This man, as Fay recalled him in that long minute of his stare across
the table, was bulky, rough-voiced and disfigured by a giant scar which
ran from the lobe of his right ear down to, and under, his chin. The
girl who now professed to be his daughter resembled him in no
particular.</p>
<p class="calibre8">“Some mistake,” Fay said, rising gallantly. “I’m sure that you have
taken me for some one else.”</p>
<p class="calibre8">The girl lifted her elbows from the table, opened her parasol, raised
it and asked:</p>
<p class="calibre8">“Wont you sit down? I haven’t mistaken you for some one else. You are
Chester Fay, alias Edward Letchmere—an old friend of my father’s.”</p>
<p class="calibre8">Fay took off his plaid cap and sat down. He fingered a
platinum-and-gold cigarette-case, removed a monogrammed cigarette,
scratched a match on the bottom of the table and inhaled a deep breath
of Turkish-scented smoke.</p>
<p class="calibre8">“By what other name was your father known?” he tested her.</p>
<p class="calibre8">“He was sometimes called ‘Big Scar’!”</p>
<p class="calibre8">“Where were you born?”</p>
<p class="calibre8">“In Chi. I was with Micky Gleason’s mob in Paris. I worked deep-sea
with Minnie May, ‘The Duchess.’ I have been trained by my father to
dip, forge, stall for pennyweighting and ever so many useful things.”</p>
<p class="calibre8">“You don’t look it!” Fay exclaimed. “Upon my word I don’t believe
you’re Charlie Laurie’s daughter. Why, he is hardly your kind—at all.”</p>
<p class="calibre8">“Laying aside compliments, Mr. Fay, and how I found where you were here
in California and—so many things that take up time, I’ve got a
proposition to make which should be mutually advantageous. In other
words you are the only man in the world I would let in on a great, big
job.”</p>
<p class="calibre8">Fay removed his cigarette from his mouth and eyed the ashes. He ran his
slender fingers through his prematurely gray hair. His face lighted
with retrospection.</p>
<p class="calibre8">“Go on Miss—”</p>
<p class="calibre8">“Saidee Isaacs, they call me, although you know my name is Saidee
Laurie.”</p>
<p class="calibre8">“Proceed, Miss Isaacs, with your plan.”</p>
<p class="calibre8">The girl’s olive-shaped and tinted eyes swept the golf-links. She
brushed back a lock of sherry-colored hair.</p>
<p class="calibre8">“I’m going to help you crack a safe,” she informed him, “The safe—or
goopher, as Father would call it—is in the brokerage office of Frank
Robertson Pope, otherwise known in California get-rich-quick circles as
‘The Black Cougar.’”</p>
<p class="calibre8">Fay crushed his cigarette. A film dropped over his eyes. His lips
hardened to a straight line.</p>
<p class="calibre8">“Go on,” he said.</p>
<p class="calibre8">“You know the man?”</p>
<p class="calibre8">“I know him!”</p>
<p class="calibre8">“He deserves no mercy?”</p>
<p class="calibre8">“None.”</p>
<p class="calibre8">“He is a disgrace to all the good crooks in the world—a coward and a
hypocrite. He has served time—for usury. He got out of San Quentin by
squealing on his pals. He is trimming suckers right and left. He makes
suicides of widows. He fills the poorhouses. He is within the law—but
far guiltier than you or I.”</p>
<p class="calibre8">Fay realized that he faced a very well-informed young woman. He
moistened his lips and gazed over the golf-links. No one was within
driving distance of the Nineteenth Hole.</p>
<p class="calibre8">“Briefly,” he suggested, “you believe me to be Chester Fay, an old
friend of your father’s. You located this Chester Fay through the
underworld. You want him to help you turn off a trick on ‘The Black
Cougar.’ What would there be in it for him if this trick were
successfully turned?”</p>
<p class="calibre8">“One hundred thousand for him and the same for me.”</p>
<p class="calibre8">“How is the goopher protected?”</p>
<p class="calibre8">“By every known electrical device. It is in the back of his office. It
consists of three layers of vanadium steel and two layers of
fireproofing. The circular door has two dials and a time-lock. The
inner door has one dial. The day door has a flat-key lock.”</p>
<p class="calibre8">“What is above the vault?”</p>
<p class="calibre8">“A photograph studio.”</p>
<p class="calibre8">“What is in the basement?”</p>
<p class="calibre8">“The basement is occupied by a cigar-store. It doesn’t close until
twelve o’clock. There’s a pool-room in the back. Sometimes men play
poker there all night.”</p>
<p class="calibre8">“How many watchmen in the building?”</p>
<p class="calibre8">“One, employed by ‘The Black Cougar.’ He can’t be bought. I’ve tried.”</p>
<p class="calibre8">“The regular thing, then—watchman, electric protection, standard vault
built by Seaber, I suppose?”</p>
<p class="calibre8">“No—by Terryton!”</p>
<p class="calibre8">“A good box, but soft on top.”</p>
<p class="calibre8">The girl tilted her parasol so that her face was in a shadow.</p>
<p class="calibre8">“Are you game?” she asked.</p>
<p class="calibre8">“The proposition strikes me as being peculiar. Suppose I am Chester
Fay. How do I know that you are Charlie Laurie’s daughter?”</p>
<p class="calibre8">“Would this convince you?” The girl reached in her breast and laid a
folded photograph on the table. Fay picked it up. It was a good
likeness taken in a rogues’ gallery. A tag with a number was about the
girl’s neck. Her eyes were straight before her. Beneath the card was
the notation:</p>
<p class="calibre8">“Saidee Laurie, _alias_ Saidee Isaacs, _alias_ English Kitty.
Shoplifter, gun-moll, con-woman, gay-cat for Continental mobs of
safe-blowers and card-sharpers. Sentences, suspended each instance:
Auburn, N. Y., Rochester Workhouse, Rochester, N. Y., Bridewell,
Chicago, Ill.”</p>
<p class="calibre8">Fay turned the card over, then handed it back.</p>
<p class="calibre8">“Rather convincing,” he said. “Frankly, you don’t look it.”</p>
<p class="calibre8">“Are you going to help me?”</p>
<p class="calibre8">Fay traced circles on the iron table-top. He stared at his golf-bag. He
considered the situation from a score of angles. The thing that swayed
him and inclined him toward the proposition was the fact that “The
Black Cougar” was fair game for any self-respecting crook.</p>
<p class="calibre8">“I make one stipulation,” he said, finally. “Buy out the photograph
gallery and establish yourself above the vault. I’ll advance the
money.”</p>
<p class="calibre8">“I have the money. I had already figured on that,” was the girl’s
reply.</p>
<p class="calibre8">“You seem to have thought of most things. Do you know that if that
vault is taken by either an electric-arc or an oxy-acetylene blow-pipe,
I will be suspected?”</p>
<p class="calibre8">“I didn’t think of that.”</p>
<p class="calibre8">“It is a fact! You see the police and the private agencies know a man
by his work. How can we take that vault in a new way? How can I go
through three layers of vanadium steel?”</p>
<p class="calibre8">“Has it ever been done?”</p>
<p class="calibre8">“Yes, by the introduction of graduated blasts of nitroglycerin.”</p>
<p class="calibre8">“Father would have opened the safe that way.”</p>
<p class="calibre8">“Your father was of the old school. The presence of a watchman, the
poker-players in the basement, the natural suspicion which ‘The Black
Cougar’ will have concerning his ill-gotten gains, calls for a new
idea—one that will be effective and noiseless. Can you think of a
way?”</p>
<p class="calibre8">“No. That’s why I came to see you.”</p>
<p class="calibre8">Fay crossed his legs and leaned away from the table. The girl’s face
was still in the shadow cast by her parasol. Again the thought came to
him that the whole proposition was a trick. Perhaps she was a tool in
the employ of “The Black Cougar.” Perhaps the police had sent her to
Short Hills in order to arrange a trap. He dismissed this thought,
however. The police of Los Angeles would have been anxious to make a
quick arrest. The price on his head amounted to five figures.</p>
<p class="calibre8">“I’ll chance you!” he said. “The only motive I see for your actions is
the one you’ve explained. You want to rob a robber—cheat a cheater.
Frank Robertson Pope, which is only one of ‘The Black Cougar’s’ names,
has amassed too much money, in too rotten a way. I understand he has
the longest and most complete sucker-list of any bucket-shop broker in
this country.”</p>
<p class="calibre8">“We can steal that and sell it.”</p>
<p class="calibre8">“There are people who would buy it?”</p>
<p class="calibre8">“I know a very well-known firm in New York and Washington that would
pay fifty thousand dollars for the list.”</p>
<p class="calibre8">“Perhaps that is all Pope has in the vault?”</p>
<p class="calibre8">The girl dropped her parasol to the turf, rose, leaned over the table
and said:</p>
<p class="calibre8">“If that _were_ all, would you still be game enough to try it?”</p>
<p class="calibre8">Fay stood erect. He pulled on his cap, pocketed his cigarette-case and
smiled down at Saidee Isaacs.</p>
<p class="calibre8">“After thinking the matter over—I will do anything in my power to beat
‘The Black Cougar.’ He is within the law and you and I are outside the
law. But I’ll take my chances against his, on Judgment Day.”</p>
<p class="calibre8">Saidee Isaacs thrust out an impulsive hand.</p>
<p class="calibre8">“I like you immensely for saying that, Chester Fay. I knew I’d like
you—from what Father told me. You see I visited him when I was East,
last week. He gave me directions how to find you here at Short Hills.”</p>
<p class="calibre8">Fay recalled a letter which he had written to Charlie Laurie. In it had
been a code telling where to send an answer. There was very little
danger in doing this, for prison guards were notoriously stupid.</p>
<p class="calibre8">“That explains everything I wanted to know,” he said. “You had better
hurry to Los Angeles and secure that studio.”</p>
<p class="calibre8">“I’ve already looked it over. I can buy all of the fixtures and assume
the lease. I’ll set up a Miss Sorjoni, Photographer of Children. You’ll
have until day-after-tomorrow to find out a way to cut down through the
vault.”</p>
<hr class="calibre9"/>
<p class="calibre8">Fay watched the girl cross the lawn to the clubhouse, where she entered
a taxi which was waiting under the _porte-cochère_. The taxi
disappeared over the dusty surface of a winding road that led to Los
Angeles, via Pasadena.</p>
<p class="calibre8">He wasted no time. Picking up his golf-bag, he strode lankily to the
showers, bathed, took the small elevator to his room and there changed
his clothes. He went to Los Angeles, by trolley. His costume was
calculated to disarm any suspicion. A closely woven Panama hat shaded
his features. A plaid suit and square-toed shoes gave him the
appearance of a remittance-man in town for the theater.</p>
<p class="calibre8">Of Robertson Pope, otherwise “The Black Cougar,” he learned
considerable. The bucket-shop operator lived in an Italian-period
palace on one of the principal avenues given over to motion-picture
magnates, oil-boomers and actresses. Pope had a string of seventy
branch offices extending from San Diego to Boston, Mass. The
Government, through the Post Office Department, had recently been
defeated in the higher courts by “The Black Cougar’s” attorneys. It had
been proved that his business was legitimate.</p>
<p class="calibre8">Fay stayed in Los Angeles that night and went over the record in the
Building Inspector’s Office the next morning. He was able to do this by
posing as an architect in search of villa specifications. He traced on
rice-paper, a working drawing of the building wherein Pope had his main
office. The floor plans gave the location of the photograph studio, the
construction of the ceilings and the thickness of the walls. A skylight
was shown above the studio.</p>
<p class="calibre8">He rounded out a day’s hard work and went back to Short Hills. The plan
he had in mind took slow form. Many details depended on Saidee Isaacs.</p>
<hr class="calibre9"/>
<p class="calibre8">A phone call from her studio, the next afternoon, brought him from the
golf-links.</p>
<p class="calibre8">“I’ve just moved in,” she said. “Everything is topsy-turvy. Wont you
bring little Cecil tomorrow? I’ll have my camera up then. Good-by.”</p>
<p class="calibre8">“Talks like a man,” thought Fay. “Snappy and direct.”</p>
<p class="calibre8">He passed the day considering the plan of relieving “The Black Cougar”
of his available wealth. The bucket-shop operator was shrewder than
most men of his type. He was a crook, at heart. Fay realized that no
one, not excepting millionaires, raised a louder outcry when robbed
than a thief himself. Old Charlie Laurie had once said, “The poor man
never squeals when trimmed, but look out for the big grafters.”</p>
<p class="calibre8">Fay’s precautions when visiting the studio consisted in wearing a
baggy, tweed suit, yellow gloves and sun-glasses. He found a child who
could play the part of “Cecil” for the first visit.</p>
<p class="calibre8">Saidee Isaacs had accomplished the impossible. A new sign was hung in
the place of the old one. New curtains were at the front windows. Grass
matting covered the floor of the reception-room. The camera she had set
up between the studio and the dark-room was a fair imitation of a good
one. It was covered with a black cloth.</p>
<p class="calibre8">“This is all right,” Fay said to her. “But there’s one thing to be
changed. That skylight has got to be moved south about seven feet.” He
consulted the rice-paper tracing while the boy sat in the
reception-room.</p>
<p class="calibre8">“Why has it got to be moved?”</p>
<p class="calibre8">Fay pointed to the floor of the photographing-room. “The vault is in
the wrong place. We can’t move it. We have got to move the skylight.”</p>
<p class="calibre8">“Has the skylight anything to do with cutting through the top of the
safe?”</p>
<p class="calibre8">“Everything, Saidee.”</p>
<p class="calibre8">“Then it’ll be moved where you say, if a carpenter can do it.”</p>
<p class="calibre8">The other tenants of the Bradock Building, so called from a stone over
the doorway to “The Black Cougar’s” brokerage offices, had ample
opportunity to observe Miss Saidee Sorjoni, Photographer of Children.
She wore shiny celluloid cuffs and a neat white ruching about her neck.
Her fingers were stained with developer. Beneath this yellow stain was
a coating of collodium—a sovereign cure for fingerprints.</p>
<p class="calibre8">The boy, whom Fay had picked up in the street, held down the position
of messenger. He could be sent on almost any kind of pretext. He had an
innocent though dirty face, that disarmed suspicion.</p>
<p class="calibre8">Fay took his time in cutting through the floor over the exact center of
“The Black Cougar’s” customers’ room—a place of wire-wickets, tickers,
soft chairs and a long board upon which two boys changed the day’s
quotations with lightning-like celerity.</p>
<p class="calibre8">The hole he made through the floor of the studio’s front office was
cone-shaped and ended in a quarter-inch opening. A view could be
obtained by means of this peekhole of “The Black Cougar’s” private
den—adjoining the vault.</p>
<p class="calibre8">Fay neatly fitted this opening with a trapdoor covered by a small
table. Upon this he placed current magazines and samples of
photographic art—left by the late owner of the studio.</p>
<p class="calibre8">“Come here, Saidee,” he said to her one day. “Get down and watch Pope.
What is he doing at his desk? What is that he has carried from the
vault?”</p>
<p class="calibre8">She dropped to her knees and looked through the opening. She bent
lower. Suddenly she rose and arranged her skirt.</p>
<p class="calibre8">“That is queer,” she said. “He took a large spool of wire out of the
vault, set it on a spindle, passed one end of the wire through a little
box he has on his desk and then started winding the wire on another
spool. He’s doing it now.”</p>
<p class="calibre8">Fay lay flat on the grass matting. He saw, through the circular
opening, the board-room, the grill and ground-glass partitions and the
thick purple neck and bald head of “The Black Cougar.” The bucket-shop
operator was doing nothing more interesting than winding wire from one
spool to another. He stopped now and then to examine a tape which came
out of the box on his desk. He reached suddenly. He tore off this tape,
pulled down the cover of his desk, sprang from his swivel-chair and
went to a window which opened into the compartment occupied by a score
of stenographers.</p>
<p class="calibre8">“Petroleum, preferred,” he snarled as a timid girl took the tape. “Send
them Red Letter No 10. Follow up, one day week. Quote 6574 asked. Get
me?”</p>
<p class="calibre8">The girl whispered her answer. She disappeared beyond Fay’s range of
vision. He waited and watched “The Black Cougar” unwind the wire, tuck
the spool under his thick arm and hurry into the vault. An inner door
slammed. The bucket-shop operator came out, closed the outer door,
twirled the combinations and started pacing the thick Turkish rug.</p>
<p class="calibre8">“That’s a new one,” said Fay to Saidee Isaacs. “We’ll have to open that
vault to find out what that spool of wire is for!”</p>
<p class="calibre8">“Could it have been an electrical connection to the little box on his
desk?”</p>
<p class="calibre8">“No! It was not insulated wire. It looked to me like fine steel or iron
wire—perhaps finer than the wire used in the smallest size hairpin.”</p>
<p class="calibre8">“The spool was big enough.”</p>
<p class="calibre8">“There was all of a thousand feet of wire on it, Saidee.”</p>
<p class="calibre8">“It’s some trick.”</p>
<p class="calibre8">Fay nodded. He got down on his knees and watched “The Black Cougar.” He
rose and covered up the hole in the floor. Before going out he said to
the girl:</p>
<p class="calibre8">“I’m going to have some things sent up. Tonight I start work over the
safe. We shall enter the vault by Sunday, when no one is in Pope’s
office.”</p>
<p class="calibre8">“How are you going to cut that vanadium steel? Father told me once it
was the hardest kind of metal.”</p>
<p class="calibre8">Fay glanced at the skylight which had been changed to a new position.
“I told you,” he smiled, “that I had an idea. It’s so far out of my
line that the police wont suspect me. I’ve been accused of using
thermite, the oxy-acetylene blow-pipe, the electric-arc, with a
water-rheostat, and other devices. This time I’ll go everybody one
better. The material will be up by special messenger.”</p>
<p class="calibre8">Fay left the studio. His thoughts were not on the method he intended
using to open “The Black Cougar’s” strong box. They drifted between two
mysteries—the matter-of-factness of Saidee Isaacs, who was certainly
unemotional, and the spool of wire which Pope had locked in the vault.</p>
<hr class="calibre9"/>
<p class="calibre8">The shop Fay visited that afternoon, and where he waited while a
glazier finished the last of his order, was far enough from the center
of the city to admit of no danger from the police.</p>
<p class="calibre8">“You see,” Fay told the proprietor, “I am making some experiments at an
ostrich farm near Pasadena. Be careful when you pack the mirrors. I’ll
have to carry them on a trolley-car.”</p>
<p class="calibre8">He took a huge, well-wrapped package after paying the man the price
demanded, and rounded the block. He found a messenger standing in front
of a telegraph-office.</p>
<p class="calibre8">“For Miss Saidee Sorjoni, photographer,” he told the boy. “She’s
located in the Bradock Building. Here’s a four-bit piece. Don’t break
anything.”</p>
<p class="calibre8">Fay watched the boy until he had disappeared. He went through narrow
streets to a second glazier’s. This man had constructed two halves of a
hollow lens. This lens was about three feet in diameter. It was far
from being accurate.</p>
<p class="calibre8">“A burning-glass,” said Fay, “does not necessarily need to be solid. I
intend to paste the edges together with plaster of Paris and fill the
whole thing with clear water.”</p>
<p class="calibre8">“Going to make a sun-motor?” asked the artisan.</p>
<p class="calibre8">“Something like that. Wrap it in tissue paper. I don’t want to break it
on my way to Pasadena.”</p>
<p class="calibre8">Having thus thrown off all clues, Fay carried the hollow lens to the
studio. Saidee Isaacs had received the package, left it unopened on the
dark-room floor and pinned a brief note to the table in the
reception-room.</p>
<p class="calibre8">“Gone for the day. Have a headache. Will be at my hotel if you want to
call me up.”</p>
<p class="calibre8">Fay destroyed the note, took off his coat, tie and collar and started
to work rigging the mirrors and the hollow lens upon a scaffolding
beneath the skylight.</p>
<p class="calibre8">It was shortly after midnight when he finished adjusting the device to
his satisfaction. He went to the window, peered out, saw the
night-watchman talking with a uniformed policeman on the street-corner,
and smiled with some slight degree of satisfaction.</p>
<p class="calibre8">The hole he cut directly over the vault and beneath the scaffolding was
aimed to miss two floor-beams which he had located by a line of
nail-heads. He reached, before dawn, the first and upper plate of
vanadium steel which protected the vault. He cleared a square space and
emptied the plaster and shavings in a box.</p>
<p class="calibre8">A neat trapdoor, hinged on the lower side, was the work of a silent
hour wherein he used screws instead of nails on the hinges. He covered
the floor with a matting, swept out the corners for chance evidence and
washed up.</p>
<p class="calibre8">The arrangement of mirrors, the hollow lens, which had not yet been
filled with water, the adjustable scaffolding beneath the skylight, all
resembled a part of a photograph outfit designed to intensify the
overhead rays of the California sun. The lens reminded Fay of a large
goldfish bowl.</p>
<p class="calibre8">Saidee Isaacs came in at seven o’clock. She looked at the scaffolding,
removed her gloves, lifted her broad-brimmed hat from her
sherry-colored hair and exclaimed:</p>
<p class="calibre8">“You’re the limit! I thought I’d got in the wrong studio.”</p>
<p class="calibre8">“I’ve been working all night, Saidee.”</p>
<p class="calibre8">“What is that thing?”</p>
<p class="calibre8">“An up-to-date method of cutting steel—particularly vanadium, chrome
or high-carbon stuff. It’s new in the history of safe-breaking. There’s
nothing like being original—even in your sinning.”</p>
<p class="calibre8">“But will it work?”</p>
<p class="calibre8">“I’ll tell you at noon. Lock the front door, pull down the blinds, and
if the boy comes send him away. We’re going to cop ‘The Black Cougar’s’
bank-roll by Sunday. All we’ll leave him is the rubber-band.”</p>
<p class="calibre8">“I’m curious about that spool of iron wire, Chester.”</p>
<p class="calibre8">“Same here.”</p>
<p class="calibre8">“I don’t see why he should lock up a ridiculous thing like that.”</p>
<p class="calibre8">“He’s got the reputation of being very clever. He’s been an usurer—for
the underworld. He’s a telegraph operator and an electrician of sorts.
I think he was mixed up with Larry Anderson and ‘Blondie’ in a
phantom-circuit around a pool-room’s fast wire. I expected to find the
vault protected on top, but they overlooked that. Queer, isn’t it, that
a clever man like him—a fiend for money and a brain-worker of the
first class—should neglect an important trifle?”</p>
<p class="calibre8">Saidee Isaacs said: “They all overlook the essential trifle. We must be
careful we don’t overlook anything. I’m not afraid of the police half
as much as ‘The Black Cougar.’”</p>
<p class="calibre8">Fay glanced at the matting over the trapdoor. “You’re sure there’s
going to be two hundred thousand in the vault?”</p>
<p class="calibre8">“His last statement given to the post-office authorities showed that
much, or more, balance. He also has money with the Coast National.”</p>
<p class="calibre8">“How do you know?”</p>
<p class="calibre8">“It was in the newspapers three weeks ago when the trial was going on.”</p>
<p class="calibre8">Fay was satisfied with the girl’s answer. He heard her moving around in
the dark-room. He rolled the grass matting to one side and lifted the
trapdoor over the vault.</p>
<p class="calibre8">The bright sunlight illuminated the room. A beam reflected from the
mirrors on the scaffolding. The city roared beyond the locked door.</p>
<p class="calibre8">Fay drew a piece of blue chalk from his pocket, knelt down on the
vanadium steel plate and carefully outlined an oblong—three feet long
and two feet wide. He rose and stared at his design. He went to work
filling the hollow lens with water. Saidee mixed the plaster of Paris.
The edges were quickly sealed. A small opening was left at the top.
Through this aperture the air rushed out as the liquid ran in. This
hole was finally stopped with chewing-gum.</p>
<p class="calibre8">“Useful stuff,” said the girl. “With that and a hairpin you could fix
anything.”</p>
<p class="calibre8">Fay climbed upon the table and adjusted the hollow lens. He blocked one
edge so that it could be shifted. He raised and lowered the frame upon
which it rested. A sudden flash, followed by a small cloud of smoke,
indicated that the focused rays had touched the woodwork at the edge of
the trapdoor.</p>
<p class="calibre8">“Hotter than any electric-arc,” he said. “Now watch when I get the
point of light on the vanadium. This is the same scheme old Archimedes
used centuries ago to burn ships.”</p>
<p class="calibre8">“I thought he used mirrors—”</p>
<p class="calibre8">“Perhaps he did. I’ve got mirrors to heat the vanadium and keep the
temperature of the plate high. Our chief difficulty will be in the loss
of heat due to radiation. The—”</p>
<p class="calibre8">Saidee Isaacs sprang back from the opening. A sizzling sounded. Blue
smoke filled the room. The plate was being melted along the line Fay
had drawn. The movement of the sun, from east to west, was changing the
position of the ray.</p>
<p class="calibre8">Fay climbed to the table and adjusted his curved mirrors. He focused
them about the spot of whiter light that coned down from the hollow
lens. The California sun is bright. The skylight did not require
opening.</p>
<p class="calibre8">“We’re getting on!” he exclaimed. “I’ve gone through the first plate
and reached the fireproofing. I’ll have to change the lens and spot
across the oblong. My east and west lines are easy. The cross lines
will take some time.”</p>
<p class="calibre8">“How about the heat melting the paint in the vault?”</p>
<p class="calibre8">“The asbestos layers between the plates will prevent that. See! We were
lucky that ‘The Black Cougar’s’ was both fireproof and burglar-proof.
But then, Saidee, they make them all that way.”</p>
<p class="calibre8">The girl shielded her eyes and leaned over the opening in the floor. A
narrow channel showed where the spot of light had cut through the first
vanadium plate. The fused metal formed bubbles along the edges. Beneath
the bubbles was the white fireproofing material.</p>
<p class="calibre8">Fay pulled her back. “Look out for that ray,” he said. “I estimate its
temperature to be all of five thousand degrees Fahrenheit. That’ll melt
anything—particularly high-carbon steel.”</p>
<p class="calibre8">“Could you have done the same thing with the oxy-acetylene blow-torch?”</p>
<p class="calibre8">“No! You have to have an edge to start on. All we had here was a flat
plate. This is the only way we could have done it. The electric-arc
requires a heavy amperage—far more than can be obtained from a
lamp-circuit. Besides, the coppers would suspect me if I used an arc.”</p>
<p class="calibre8">“They’re going to think this was done by electricity.”</p>
<p class="calibre8">“No, they’re not. We’ll leave the mirrors behind us. It’ll throw them
off my trail.”</p>
<p class="calibre8">Saidee went out at noon and returned with two lunches bought at a
restaurant. She found Fay standing on the table and holding the lens so
that it spotted tiny blisters first along the north, then south, lines
of the oblong. The sun went behind a cloud. Fay sprang to the floor
lightly. He sat down, turned in his chair, and stared at the top of the
vault. “We’ve got the first plate pretty well cut through,” he said.
“Suppose you look and see what ‘The Black Cougar’ is doing.”</p>
<p class="calibre8">She rose and dusted her knees after a long study of the operator’s
office.</p>
<p class="calibre8">“He’s got that spool of iron wire on his desk. He’s been running it
through the little box. There’s a lot of tape scattered about. It must
be a quotation machine of some kind, Chester.”</p>
<p class="calibre8">“No. The days of the old swindle are gone. He couldn’t get away with
fake quotations. He may have a fast wire and a slow wire in his
offices. The customer trades on the slow wire while the firm sells on
the fast wire. But then, I understand ‘The Black Cougar’s’ business is
done mostly through the mails. That spool he has down there has
something to do with his mail game. Maybe it’s a system to beat the
market.”</p>
<p class="calibre8">“There never will be such a thing!”</p>
<p class="calibre8">Fay nodded. “You’re very wise,” he mused, staring directly at her. “You
don’t remind me of your old man, at all. He did a lot of very heavy
work—such as blasting and using a can-opener. You inherited your
quick-wittedness from your mother’s side, I suppose?”</p>
<p class="calibre8">“Partly.”</p>
<p class="calibre8">Fay went to work with the lens as the sun came out. He finished the
first cutting by two o’clock. He lifted the plate out, after allowing
it to cool. It was three quarters of an inch in thickness. Its edges
were brittle as glass.</p>
<p class="calibre8">“I’ll cut away the fireproofing,” he told Saidee, “and get ready for
the sun tomorrow. I expect, from what I know of the Terryton boxes,
that the middle plate will be almost twice as thick as the outer one.
That means a lot of burning.”</p>
<p class="calibre8">Saidee Isaacs attended to the meals. She watched the studio door in
case of interruption. Once Fay saw her adjust the shade at a certain
height. This shade could be seen from the street.</p>
<p class="calibre8">He recalled an old signal used by house prowlers to indicate that it
was all right for pals to enter the house. The thought flashed through
him that the girl had a confederate outside. He puzzled over this
matter, without speaking to her about it. There seemed no reason to
suspect treachery on her part.</p>
<p class="calibre8">Her interest in robbing “The Black Cougar” reached a high point when he
succeeded, after two days’ work, in cutting out the second, or central,
plate of the vault. This plate was an inch and a quarter in thickness.
It was designed to resist drills. It was hardened on the surface and
somewhat soft inside.</p>
<p class="calibre8">The fumes and smoke from the burning metal floated through the
skylight. The heat of the hot spot was sufficient to vaporize most
metal. Fay added to this heat the radiations from the concave mirrors.
He feared, at times, that there would be indication inside the vault
that work was going on above.</p>
<p class="calibre8">Saidee, on watch over the peekhole, kept him informed of “The Black
Cougar’s” movements. The bucket-shop operator had not used the spool of
wire for two days. He had entered the vault but twice. Each time he
came out with yellow bills in his hands.</p>
<p class="calibre8">“Tomorrow’s Saturday,” said Saidee. “That’s a half-holiday for brokers.
There wont be anybody in the office during the afternoon or Sunday. We
must go through the last plate and get that money.”</p>
<p class="calibre8">Fay washed up and put on his coat.</p>
<p class="calibre8">“I’ll attend to our getaway,” he said. “I’ll bring a lot of tourist
folders and lay them around the reception-room. They’ll all indicate to
the average sleuth that we fled to Seattle and from there took an
Alaskan boat.”</p>
<p class="calibre8">“There isn’t a dick in this town who wouldn’t fall for that,” she said.
“The detectives I’ve met are a lot of boobs. There’s only one or two in
the Secret Service who are any good.”</p>
<p class="calibre8">“Old Triggy Drew?”</p>
<p class="calibre8">“Yes, and Marway—the man who was never seen by a criminal.”</p>
<p class="calibre8">Fay opened the door.</p>
<p class="calibre8">“I’ve heard of him,” he said going out.</p>
<p class="calibre8">The railroad and steamship folders were secured. Saidee’s inspection of
her room at the hotel, and a general search of the photograph studio
for overlooked clues, left Saturday and Sunday for work. It was that
period of the California summer when the sun is brightest. The girl
reported the office below clear of clerks and customers. The janitress
came and scrubbed up. The watchman made his rounds. The time-lock on
the vault’s outer door had been set by “The Black Cougar” so that no
one could open it until Monday morning.</p>
<p class="calibre8">Fay took the chance. He went through the inner plate Saturday
afternoon. He burned a larger hole, set the lens and allowed the high
swing of the overhead sun to trace out a line. Smoke and vapor rose
from the sizzling pencil of light. Drops of molten metal fell within
the vault, the floor of which was not carpeted.</p>
<hr class="calibre9"/>
<p class="calibre8">The job was finished soon after noon on Sunday. Fay looped a wire
around the plate and tapped its edges with a hammer. The last of the
metal cracked. The plate swung free. The way was open.</p>
<p class="calibre8">“I’ll go down!” exclaimed Saidee.</p>
<p class="calibre8">“No, not yet. Let the things cool off. Help me get the lens apart.
We’ll destroy it. We’ll clean up everything incriminating.”</p>
<p class="calibre8">“But—”</p>
<p class="calibre8">“Don’t be in such a hurry. The vault may be ‘bugged’ inside. Suppose
there’s an electric mat?”</p>
<p class="calibre8">“Oh, you know best! But I’m very anxious.”</p>
<p class="calibre8">Fay took his time. He coolly moved to the front window, raised the
blind an inch and looked out. Autos and trolley-cars hurried by.
Policemen stood directing traffic. Tourists thronged the street.</p>
<p class="calibre8">He went to Saidee Isaacs. She helped him lift down the lens. He poured
out the water, smashed the two halves with the hammer, and tossed the
fragments into a box.</p>
<p class="calibre8">“They’ll never suspect what that was,” he said. “Now, give me your hand
and lower me into the vault. I can’t touch the edges yet. They’re still
hot!”</p>
<p class="calibre8">She braced herself over the opening, grasped his wrists, and lowered
him. Her strength was considerable. He felt her face close to his own
as she leaned.</p>
<p class="calibre8">“Let go,” he said, steadying his legs.</p>
<p class="calibre8">He landed on the metal floor of the vault. The light that streamed
through the jagged opening was sufficient for his purpose. He started
removing ledgers and cash-boxes to the center of the strong-room. Some,
but not all, of these boxes contained money. It took him ten minutes,
no longer, to count up the spoil.</p>
<p class="calibre8">Allowing for small bills and silver, he had obtained thirty-seven
thousand dollars. He had expected two hundred thousand.</p>
<p class="calibre8">He bundled up the larger packages of bills, snapped rubber-bands about
them and began a search of the shelves. He overlooked nothing. Book
after book was torn apart.</p>
<p class="calibre8">Having finished with the last ledger, he stared up at Saidee’s intent
face framed in the jagged opening.</p>
<p class="calibre8">“You’re a fine pal!” he said. “I’ve only got thirty-seven grand. You’ve
steered me wrong!”</p>
<p class="calibre8">“Have you found the sucker-list?”</p>
<p class="calibre8">“No. I didn’t see it.”</p>
<p class="calibre8">“Look around. It must be there. He probably had no copy. He wouldn’t
trust anybody with a copy. It is far more important than the money.”</p>
<p class="calibre8">Fay coolly tossed up the bundle of bank-bills. He hesitated.</p>
<p class="calibre8">“Look again—it’s not here,” she said. “Look on the shelves. See if
there isn’t a secret panel, or something.”</p>
<p class="calibre8">Fay had already searched for any break in the metal of the vault. It
was smooth and enameled. He regarded the remaining objects.</p>
<p class="calibre8">“The spools of iron wire are here.”</p>
<p class="calibre8">“Give one of them to me. Put it in my hands.”</p>
<p class="calibre8">“It’s very heavy. We might as well leave them.”</p>
<p class="calibre8">“No! We must not overlook a single thing. Hand me a spool. I can lift
it.”</p>
<p class="calibre8">Fay poised a heavy spool between his fingers. Saidee drew it through
the opening. He waited until she lowered a short piece of clothes-line.
He went up this, hooked his knee over the edge of the plate, and rose
to her side.</p>
<p class="calibre8">“We might as well split the money two ways and go,” he said coldly.
“I’m not exactly satisfied. I should never have gone into this thing.
We’ve smeared things up. We’ve left more or less of a trail and gotten
very little for our trouble.”</p>
<p class="calibre8">Saidee sat on the floor. She started searching through the torn books.
Now and then she glanced at Fay without saying anything. Disappointment
stamped her features when she finished. She projected the package of
money toward him with a sharp kick.</p>
<p class="calibre8">“It’s all yours, Chester!”</p>
<p class="calibre8">“No. I’m not that kind of a man. But you’re a foolish little moll. Here
we’ve gone and laid ourselves open to twenty years in stir for next to
nothing. We haven’t even put a dent in ‘The Black Cougar’s’ bank-roll.
The chances are that he transferred most of his ill-gotten gains to the
Coast National Bank.”</p>
<p class="calibre8">“All I wanted was the sucker-list. That would have put him out of
business. He has about twenty thousand preferred names of boobs in this
country who will bite at anything.”</p>
<p class="calibre8">Fay scraped the collodium from his finger-tips. He washed his hands,
went through the studio rooms, looked everywhere for possible left-over
clues, and then said:</p>
<p class="calibre8">“Come on. I’ll carry the money. We might as well leave here.”</p>
<p class="calibre8">She reached down and lifted the spool of iron wire. “You take the money
and I’ll take this,” she said at the door. “We’ll separate. I may have
to come back here—so give me the key.”</p>
<p class="calibre8">“What for?”</p>
<p class="calibre8">Fay caught a direct stare full of meaning. “You’re not a boob, though
you fell like one. My name isn’t Saidee Laurie. It’s Saidee Isaacs of
the Secret Service, Post Office Department, at present. We intercepted
your note to Charlie Laurie at Dannemora. They had me decipher your
rather simple code. The order was out to bring you in. I had been
working on ‘The Black Cougar’ case. I thought you might be of more help
outside than inside. So I posed as Charlie Laurie’s daughter and got
you to help me rob the vault. The rogues’ gallery picture was framed up
to make things more convincing.”</p>
<p class="calibre8">Fay’s eyes flashed.</p>
<p class="calibre8">“You see,” went on Saidee Isaacs, “the importance of getting ‘The Black
Cougar’s’ sucker-list overshadowed the importance of putting an end to
your activities. There was no way, through the law, that would stop the
bucket-shop operator. He had the list, and as long as it was in his
possession, he could trim the suckers. They’d buy anything, and they
wouldn’t squeal on him.”</p>
<p class="calibre8">Fay blurted: “Well, in that case you’ve lost and I have gained.
Thirty-seven thousand isn’t going back to him, nor is it going to the
Government. I’m going to keep it—for professional services.”</p>
<p class="calibre8">“It’s yours, Chester. The police have been pulled off this job. You can
go free.”</p>
<p class="calibre8">“What about the sucker-list? Who’s coming back here?”</p>
<p class="calibre8">“I may bring Marway. I may not need to bring him.”</p>
<p class="calibre8">Saidee lifted the heavy spool from her knee, “After you,” she said.
“Open the door for me. Go out to the golf-club and wait.”</p>
<p class="calibre8">“I’ll wait about twenty minutes!” he exclaimed hotly. “I suppose Marway
will order me pinched.”</p>
<p class="calibre8">“I’m in charge of the entire case. I’ve failed so far—unless—”’</p>
<p class="calibre8">“What?”</p>
<p class="calibre8">“This spool contains part of the sucker-list. I don’t see how it can.
Do you?”</p>
<p class="calibre8">Fay jerked the door open, allowed the girl to pass through, and locked
it. He thrust the key into her hand.</p>
<p class="calibre8">“Good-by,” he said.</p>
<p class="calibre8">“No. Promise you will wait on the links for me. You have my word you
wont be pinched.”</p>
<p class="calibre8">His packing of the two kit-bags in his room at the club took no longer
than fifteen minutes. He paid his bill, left his bags with a porter,
and went out on the links.</p>
<p class="calibre8">Golfers, a fair gallery, and caddies were scattered over the green. He
sat down at a table and pulled out his watch. The California sun was
sinking over the Coast Range when a taxi churned through the dust,
swung under the _porte-cochère_ and discharged Saidee Isaacs.</p>
<p class="calibre8">She crossed the turf with her face as inscrutable as ever. Her hand
darted over the table. Shading her eyes with her parasol, she
whispered:</p>
<p class="calibre8">“Sorry to keep you waiting, Chester, but we found the sucker-list. Part
was in that spool. Marway’s assistant found it ten minutes ago.”</p>
<p class="calibre8">“How?”</p>
<p class="calibre8">“By experimentation. I told Marway what I had seen ‘The Black Cougar’
doing at his desk. You remember he ran the wire through a
ticker-machine and the tape came out printed with dots and dashes?”</p>
<p class="calibre8">“I didn’t know they were dots and dashes.”</p>
<p class="calibre8">“Yes. He’s a telegraph operator—an old Phillips code man. His
stenographers could read Morse like print.”</p>
<p class="calibre8">Fay began to see the purpose of the wire.</p>
<p class="calibre8">“The sucker-list,” continued Saidee, “is magnetized in the fine wire
that is wound about the spools. Each few inches contains a name and
address in dots and dashes. The Black Cougar had an apparatus to
magnetize the wire. Marway’s assistant said this apparatus probably
consisted of a small solenoid through which the wire was drawn at the
beginning. A touch of a key would make a dot. A longer touch made a
dash. The wire was special—hard and capable of being made into a
permanent magnet.”</p>
<p class="calibre8">“Then he could read these same dots and dashes by running the wire
through the relay-ticker on his desk?”</p>
<p class="calibre8">“Yes. That part of the idea has been used in duplex telegraphy and in
seeing-over-a-wire-apparatus. You can find it in the technical books.”</p>
<p class="calibre8">“How did Marway demonstrate it?”</p>
<p class="calibre8">“By a small pocket-compass. It’s really very ingenious and simple. ‘The
Black Cougar’ kept his whole sucker-list on the spools. He has no copy
of it. He is beaten without it. He might as well go out of business.
Marway and the assistant operative are going to mail every sucker on
the list a warning letter authorized by the Government. Some of them
will get wise.”</p>
<p class="calibre8">“But most of them will fall for another swindler.”</p>
<p class="calibre8">“We did our part—pulled ‘The Black Cougar’s’ claws.”</p>
<p class="calibre8">“And I pulled the chestnuts for you.”</p>
<p class="calibre8">“Thirty-seven thousand dollars and the satisfaction of knowing you did
a good deed in a wicked world is no chestnut.”</p>
<p class="calibre8">“I’m going East on the first train tonight, Saidee.”</p>
<p class="calibre8">“Stay around. Marway would like to meet you.”</p>
<p class="calibre8">“I thought he had never been seen by a criminal?”</p>
<p class="calibre8">“You’re not a criminal. You only think you are.”</p>
<p class="calibre8">Fay leaned over the table.</p>
<p class="calibre8">“I’m a dub,” he admitted. “I’ll let you put it all over me.”</p>
<p class="calibre8">“And I let you go free with my best wishes,” said Saidee Isaacs. “Turn
for turn, Chester. Don’t write to prisons and give your address in code
lettering. I had orders to come here and arrest you—about a week ago.”</p>
<p class="calibre8">Fay flushed. She was gone across the short-cropped turf.</p>
<p class="calibre8">“I’m a dub,” he repeated, “and yet I wouldn’t have had it happen any
other way for the world.”</p>
<p class="calibre10">THE END</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?c628f000